import { guestMiddleware } from "@/middleware";
import SignIn from "@/pages/auth/SignIn";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_login/login")({
	beforeLoad: guestMiddleware,
	component: SignIn,
});
